import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import DownshiftMultiple from '../../../inputs/MultipleInput';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

// eslint-disable-next-line
import style from './_style.css';

const getRoles = (values, info) => {
    return values && values.length > 0 && info && info.security
        ? values.map((v) => info && info.security.roles.find((r) => r.id === v))
        : [];
};

class RolOptions extends React.Component {
    state = {
        value: this.props ? getRoles(this.props.values, this.props.info).filter((f) => f) : [],
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ value: nextProps.values });
    }

    handleClose = (selection) => (event) => {
        const result = selection
            ? selection.map((s) => this.props.info.security.roles.find((f) => f.id === s))
            : undefined;
        this.props.onClose(result);
    };

    handleUpdatePermits = (name, values) => {
        this.setState({
            [name]: values,
        });
    };

    render() {
        const { value } = this.state;
        const { intl, info } = this.props;
        console.log(this.props.values);
        const suggestions = info && info.security ? info.security.roles : undefined;

        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ minWidth: 250 }}
            >
                <DialogContent className={'padding_borders dialog-min-size'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <DownshiftMultiple
                            id="value"
                            label={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                            suggestions={suggestions}
                            value={value}
                            name="value"
                            onChange={this.handleUpdatePermits}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(value.filter((f) => f).map((v) => v.id))}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

RolOptions.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

RolOptions = connect(
    mapStateToProps,
    null,
)(RolOptions);

RolOptions = injectIntl(RolOptions);

export default RolOptions;



// WEBPACK FOOTER //
// ./src/components/complex/manage/user/RolOptions.js